import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import defaultStyles, { IButtonScss } from './button.scss';

import SVGIcon from 'lib/images/svg-icon/svg-icon';
import like from 'four-nets/icons/svg/icon_like-2.svg';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    likesCount?: number | null;
    isLikedByViewer: boolean;
    styles?: IButtonScss;
}

class Button extends React.PureComponent<Props> {
    render() {
        const { styles, isLikedByViewer, likesCount, ...rest } = this.props;

        return (
            <button {...rest} className={styles!.button}>
                <span className={styles!.container}>
                    <span className={styles!.text}>
                        <SVGIcon style={{ image: styles.image }} src={like} />
                        <span className={styles!.label}>
                            {isLikedByViewer ? <FormattedMessage id='UNLIKE' /> : <FormattedMessage id='LIKE' />}
                        </span>
                    </span>
                    {likesCount ? <span className={styles!.count}>{likesCount}</span> : null}
                </span>
            </button>
        );
    }
}

export default Styled(defaultStyles)(Button);
